import { ArrowLeft, Download, Mail, Phone, UserRound } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import Spinner from '../../components/Spinner';
import { SERVER_URL } from '../../api/jobBoardApi';
import { useApplicant, useJob } from '../../hooks/useJobBoard';
export default function AdminApplicantDetailsPage() {
  const { id = "", applicantId = "" } = useParams();

  const job = useJob(id);
  const applicant = useApplicant(id, applicantId);

  if (job.isLoading || applicant.isLoading) {
    return (
      <div className="flex justify-center p-12">
        <Spinner />
      </div>
    );
  }

  if (!applicant.data) {
    return (
      <div className="p-8 text-center text-slate-500">
        Applicant not found.
      </div>
    );
  }

  const item = applicant.data;

  const resume =
    item.resumeUrl ?? item.resumePath;

  return (
    <div className="mx-auto max-w-4xl space-y-6 p-4 text-left md:p-8">
      <Link
        to={`/admin/job-board/jobs/${id}/applicants`}
        className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500"
      >
        <ArrowLeft size={16} />
        Back to Applicants
      </Link>

      <header>
        <p className="text-sm font-semibold text-strivre-burgundy">
          Applicant Details
        </p>

        <h1 className="mt-1 flex items-center gap-3 text-2xl font-bold text-strivre-navy">
          <UserRound size={24} />
          {item.fullName ??
            [item.firstName, item.lastName]
              .filter(Boolean)
              .join(" ")}
        </h1>

        <p className="mt-2 text-sm text-slate-500">
          Application for{" "}
          {job.data?.title ?? "Job"}
        </p>
      </header>

      <div className="grid gap-6 md:grid-cols-2">
        <section className="rounded-lg border border-strivre-lightnavy bg-white p-6">
          <h2 className="font-bold text-slate-900">
            Contact Information
          </h2>

          <div className="mt-5 space-y-4 text-sm text-slate-600">
            <p className="flex items-center gap-2">
              <Mail size={16} />
              {item.emailAddress}
            </p>

            <p className="flex items-center gap-2">
              <Phone size={16} />
              {item.contactNumber ??
                "Not provided"}
            </p>

            <p>
              <span className="font-semibold text-slate-800">
                Status:
              </span>{" "}
              {item.applicationStatus}
            </p>

            <p>
              <span className="font-semibold text-slate-800">
                Applied:
              </span>{" "}
              {item.applicationDate ??
              item.appliedDate
                ? new Date(
                    (item.applicationDate ??
                      item.appliedDate) as string
                  ).toLocaleDateString()
                : "Not provided"}
            </p>
          </div>
        </section>

        <section className="rounded-lg border border-strivre-lightnavy bg-white p-6">
            <h2 className="font-bold text-slate-900">
                Resume
            </h2>

            {resume ? (
                <a
                    href={resume?.startsWith("http") ? resume : `${SERVER_URL}${resume}`}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-5 inline-flex items-center gap-2 font-semibold text-strivre-burgundy"
                >
                <Download size={17} />
                Download Resume
                </a>
            ) : (
                <p className="mt-5 text-sm text-slate-500">
                No resume available.
                </p>
            )}
        </section>
      </div>

      <section className="rounded-lg border border-strivre-lightnavy bg-white p-6">
        <h2 className="font-bold text-slate-900">
          Cover Letter
        </h2>

        <p className="mt-4 whitespace-pre-wrap leading-7 text-slate-600">
          {item.coverLetter ||
            "No cover letter provided."}
        </p>
      </section>
    </div>
  );
}
